import React from 'react';
import { Helmet } from 'react-helmet-async';
import { generateBreadcrumbSchema } from '../../utils/faqSchema';
import { SITE_CONFIG } from '../../config/seoConfig';

/**
 * Breadcrumb Component with JSON-LD structured data
 *
 * @param {Array} items - Breadcrumb path items (e.g., ['Docs', 'Getting Started', 'Overview'])
 * @param {string} currentPath - Current page path for schema generation
 */
const Breadcrumb = ({ items, currentPath }) => {
  const breadcrumbSchema = generateBreadcrumbSchema(items, currentPath, SITE_CONFIG.siteUrl);

  return (
    <>
      <Helmet>
        <script type="application/ld+json">
          {JSON.stringify(breadcrumbSchema)}
        </script>
      </Helmet>
      <nav aria-label="Breadcrumb" className="flex items-center gap-2 text-[13px] text-zinc-600 mb-6">
        {items.map((item, index) => (
          <React.Fragment key={index}>
            {index > 0 && <span className="text-zinc-700">/</span>}
            {index === items.length - 1 ? (
              <span className="text-zinc-400" aria-current="page">{item}</span>
            ) : (
              <span>{item}</span>
            )}
          </React.Fragment>
        ))}
      </nav>
    </>
  );
};

export default Breadcrumb;
